import React from 'react';

import Input from 'antd/es/input';
import Form from 'antd/es/form';

import { Row, Col } from 'components/layout';
import Select from 'components/Select';

const ServerForm = ({ form, locationOptions }) => {
  return (
    <Form
      form={form}
      layout="vertical"
      hideRequiredMark={true}
      onFinish={form.onSubmit}
    >
      <Row gutter={[12]}>
        <Col span={12}>
          <Form.Item
            label="Server name"
            name="device_name"
            rules={[
              {
                required: true,
                message: 'Server name is required',
              },
            ]}
          >
            <Input placeholder="Enter server name" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="CPU"
            name="cpu"
            rules={[
              {
                required: true,
                message: 'CPU is required',
              },
            ]}
          >
            <Input placeholder="Enter CPU" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Models"
            name="model"
            rules={[
              {
                required: true,
                message: 'Model is required',
              },
            ]}
          >
            <Input placeholder="Select Model" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="GPU"
            name="gpu"
            rules={[
              {
                required: true,
                message: 'GPU is required',
              },
            ]}
          >
            <Input placeholder="Enter GPU" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Location"
            name="location_id"
            rules={[
              {
                required: true,
                message: 'Location is required'
              }
            ]}
          >
            <Select options={locationOptions} placeholder="Select Location" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label="SSD"
            name="hdd"
            rules={[
              {
                required: true,
                message: 'SSD is required',
              },
            ]}
          >
            <Input placeholder="Select SSD" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Alerts"
            name="alerts_enabled"
            rules={[
              {
                required: true,
                message: 'Alerts are required',
              },
            ]}
          >
            <Input placeholder="Select alerts" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="RAM"
            name="ram"
            rules={[
              {
                required: true,
                message: 'RAM is required',
              },
            ]}
          >
            <Input placeholder="Select RAM" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Serial No"
            name="serial_no"
            rules={[
              {
                required: true,
                message: 'Serial No is required',
              },
            ]}
          >
            <Input placeholder="Enter server serial number" />
          </Form.Item>
        </Col>
      </Row>

    </Form>
  );
}

export default ServerForm;